module.exports = __webpack_public_path__ + "img/parallax-item-2-276x343.31412576.png";